import React from 'react';
import style from './constrainedImage.module.scss';
import { CachedImage, CachedImageProps } from 'acscp/components/common/cachedImage';
import classNames from 'classnames';

interface ConstrainedImageProps {
    ratio: number;
    alignBottom: boolean;
}

function croppedImageStyle(ratio: number): {} {
    return {
        padding: `${100 / ratio / 2}% 0 ${100 / ratio / 2}% 0`,
    };
}

const ConstrainedImage: React.SFC<ConstrainedImageProps & CachedImageProps> = ({ ratio, alignBottom, ...rest }) =>
    (
        <div className={classNames(style.ConstrainedImage, {[style.AlignBottom]: alignBottom})} style={croppedImageStyle(ratio)}>
            <div className={style.ConstrainedImageContainer}>
                <CachedImage {...rest} />
            </div>
        </div>
    );

export { ConstrainedImage };
